module.exports = __webpack_public_path__ + "img/lianmai_mute_orange.14a07604.svg";